import colors from './colors';
import fonts from './fonts';
import keyframes from './keyframes';

const foundationConfigs = [colors, fonts, keyframes];
export default foundationConfigs;
